module.exports = __webpack_public_path__ + "img/math.97aeb058.png";